/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetPrintLabelInfoEntry } from '../../models/set-print-label-info-entry';

export interface SetPrintLabelInfo$Params {
  containerId: number;
      body: SetPrintLabelInfoEntry
}

export function setPrintLabelInfo(http: HttpClient, rootUrl: string, params: SetPrintLabelInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setPrintLabelInfo.PATH, 'post');
  if (params) {
    rb.path('containerId', params.containerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setPrintLabelInfo.PATH = '/api/v1/Containers/{containerId}/SetPrintLabelInfo';
